import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
export const useNormalizedInput = (props, { normalize, format }) => {
    const { value, onFocus, onBlur, onChange } = props;
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = useCallback((ev) => {
        setIsFocused(true);
        onFocus && onFocus(ev);
    }, []);
    const handleBlur = useCallback(() => {
        setIsFocused(false);
        onChange && onChange(normalize(value));
        onBlur && onBlur();
    }, [onChange, value]);
    return {
        value: (isFocused || !format ? value : format(value)),
        onFocus: handleFocus,
        onBlur: handleBlur,
    };
};
//# sourceMappingURL=useNormalizedInput.js.map